import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, StarIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
import { FinalOffer } from './FinalOffer';
const testimonials = [{
  name: 'Andrea P.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=240&q=80',
  quote: 'Por primera vez sentí que alguien me explicó cómo comer saludable sin hacerme sentir culpable. Las recetas son fáciles, rápidas y realmente deliciosas.'
}, {
  name: 'Carolina M.',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=240&q=80',
  quote: 'El calendario de comidas me quitó el estrés de pensar todos los días qué cocinar. Ahora tengo toda mi semana organizada.'
}, {
  name: 'Daniela R.',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=240&q=80',
  quote: 'Me sorprendió la cantidad de recetas. Hay muchísimas opciones y ninguna se siente como una dieta aburrida.'
}, {
  name: 'Paola G.',
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=240&q=80',
  quote: 'Lo que más me gustó fue que utiliza ingredientes normales. No tuve que gastar más dinero para comenzar.'
}, {
  name: 'María C.',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=240&q=80',
  quote: 'Los jugos verdes y las recetas antiinflamatorias se convirtieron en parte de mi rutina diaria.'
}, {
  name: 'Valentina A.',
  image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?auto=format&fit=crop&w=240&q=80',
  quote: 'Pensé que comer saludable significaba dejar de disfrutar la comida. Este sistema cambió completamente esa idea.'
}, {
  name: 'Sofía T.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=240&q=80',
  quote: 'El planificador nutricional fue el complemento perfecto. Me ayuda a mantener el orden durante toda la semana.'
}, {
  name: 'Laura V.',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=240&q=80',
  quote: 'Las recetas están explicadas paso a paso. Nunca me sentí perdida mientras cocinaba.'
}, {
  name: 'Gabriela N.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=240&q=80',
  quote: 'Me encantó que todo estuviera reunido en un solo lugar. Ya no tengo que buscar recetas en diferentes páginas.'
}, {
  name: 'Patricia S.',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=240&q=80',
  quote: 'Los menús de 30 días me ahorran muchísimo tiempo y me ayudan a mantener buenos hábitos.'
}, {
  name: 'Natalia B.',
  image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&w=240&q=80',
  quote: 'Es un sistema muy práctico. Lo consulto desde mi celular cuando voy al supermercado o mientras cocino.'
}, {
  name: 'Fernanda L.',
  image: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?auto=format&fit=crop&w=240&q=80',
  quote: 'Más que un libro, siento que compré un sistema completo que me ayuda a comer mejor todos los días.'
}];
const faqs = [['¿Es un libro físico?', 'No. Código Fitness™ es un sistema completamente digital que podrás consultar desde cualquiera de tus dispositivos.'], ['¿Cuándo lo recibo?', 'Inmediatamente después de completar tu compra. Recibirás las indicaciones de acceso en tu correo.'], ['¿Puedo verlo desde mi teléfono?', 'Sí. El contenido está pensado para que puedas consultarlo cómodamente desde teléfono, tablet o computadora.'], ['¿Necesito experiencia en la cocina?', 'No. Las recetas incluyen pasos claros y están hechas para acompañarte tanto si empiezas como si ya cocinas.'], ['¿Los ingredientes son fáciles de conseguir?', 'Sí. Priorizamos ingredientes cotidianos y alternativas sencillas para que puedas adaptarlas a tu contexto.'], ['¿Puedo imprimir partes del contenido?', 'Sí, puedes imprimir las secciones que te resulten más útiles para tu organización personal.']];
export function TrustFooter() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <>
      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-340">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-341">
          <motion.header initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.55
        }} className="mx-auto max-w-4xl text-center" data-id="element-342">
            <p className="text-xs font-bold tracking-[0.22em] text-[#6d8063]" data-id="element-343">
              TU SISTEMA COMPLETO
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-344">
              Un solo sistema. Cuatro herramientas. Un cambio para toda la vida.
            </h2>
            <div className="mx-auto mt-8 max-w-3xl space-y-5 text-base leading-8 text-[#63705f] sm:text-lg" data-id="element-345">
              <p data-id="element-346">
                No tendrás que buscar recetas en diferentes páginas, descargar
                múltiples archivos o improvisar qué cocinar cada día.
              </p>
              <p data-id="element-347">
                Con CÓDIGO FITNESS™ recibirás un sistema completo diseñado para
                ayudarte a construir una alimentación saludable de forma
                sencilla, práctica y sostenible.
              </p>
              <p data-id="element-348">
                Cada recurso fue creado para complementar al anterior, guiándote
                paso a paso hacia un estilo de vida que puedas disfrutar durante
                muchos años.
              </p>
            </div>
          </motion.header>

          <motion.figure initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.65
        }} className="mx-auto mt-16 w-full max-w-6xl" data-id="element-349">
            <img src="https://cdn.magicpatterns.com/uploads/kXrZSF5Edogb3DXhE2eaqH/productos_completo_CF.png" alt="Sistema completo Código Fitness con guía principal, recetario déficit calórico, cocina antiinflamatoria y planificador nutricional" className="w-full rounded-2xl object-contain shadow-[0_16px_38px_rgba(64,72,53,0.11)]" data-id="element-350" />
          </motion.figure>

          <div className="mx-auto mt-16 grid max-w-6xl gap-5 sm:grid-cols-2" data-id="element-351">
            {[['📗 GUÍA PRINCIPAL', 'CÓDIGO FITNESS™', 'Aprende desde cero cómo alimentarte mejor, crear hábitos saludables y disfrutar la comida sin restricciones extremas.'], ['🥗 RECETARIO DÉFICIT CALÓRICO', '', 'Más de 120 recetas saludables para ayudarte a perder grasa sin dejar de disfrutar cada comida.'], ['🥬 COCINA ANTIINFLAMATORIA', '', 'Recetas, jugos verdes y smoothies para cuidar tu cuerpo desde adentro y sentirte con más energía cada día.'], ['📅 PLANIFICADOR NUTRICIONAL', '', 'Organiza tus comidas, crea nuevos hábitos y mantén el control de tu progreso de forma sencilla.']].map(([eyebrow, title, copy], index) => <motion.article key={eyebrow} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.45,
            delay: index * 0.05
          }} className="rounded-2xl border border-[#e0e5da] bg-[#fffefa] p-7 shadow-[0_8px_22px_rgba(56,69,50,0.05)] sm:p-8" data-id="element-352">
                <p className="text-[11px] font-bold tracking-[0.14em] text-[#5d7655]" data-id="element-353">
                  {eyebrow}
                </p>
                {title && <h3 className="font-display mt-4 text-2xl text-[#30452e]" data-id="element-354">
                    {title}
                  </h3>}
                <p className={`${title ? 'mt-3' : 'mt-4'} leading-7 text-[#63705f]`} data-id="element-355">
                  {copy}
                </p>
              </motion.article>)}
          </div>

          <motion.aside initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="mx-auto mt-12 max-w-6xl rounded-[22px] border border-[#d5e0ce] bg-[#edf3e8] p-7 sm:p-10" aria-labelledby="included-system-title" data-id="element-356">
            <h3 id="included-system-title" className="text-xs font-bold tracking-[0.2em] text-[#55704f]" data-id="element-357">
              TODO INCLUIDO EN TU SISTEMA
            </h3>
            <ul className="mt-7 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-358">
              {['Guía Principal CÓDIGO FITNESS™', 'Recetario Déficit Calórico', 'Cocina Antiinflamatoria', 'Planificador Nutricional', 'Más de 550 recetas saludables', 'Calendario de alimentación de 30 días', 'Meal Prep', 'Smoothies', 'Jugos verdes', 'Menús completos', 'Herramientas prácticas para toda la vida', 'Compatible con celular, tablet y computadora', 'Acceso inmediato después de la compra'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-6 text-[#4f614b]" data-id="element-359">
                  <CheckIcon className="mt-1 shrink-0 text-[#638359]" size={15} strokeWidth={2.3} aria-hidden="true" data-id="element-360" />
                  <span data-id="element-361">{item}</span>
                </li>)}
            </ul>
          </motion.aside>

          <aside className="mx-auto mt-8 max-w-6xl rounded-[22px] border border-[#dae6d3] bg-[#f1f6ed] px-7 py-8 sm:px-10 sm:py-10" data-id="element-362">
            <h3 className="font-display text-2xl leading-tight text-[#395237] sm:text-3xl" data-id="element-363">
              Todo lo que necesitas para comenzar ya está incluido.
            </h3>
            <div className="mt-4 max-w-4xl space-y-3 leading-7 text-[#5a6b55]" data-id="element-364">
              <p data-id="element-365">
                No tendrás que comprar cursos adicionales, buscar recetas en
                internet ni improvisar un plan de alimentación.
              </p>
              <p data-id="element-366">
                Todo está organizado para que simplemente abras el sistema,
                sigas las indicaciones y empieces a construir una mejor versión
                de ti.
              </p>
            </div>
          </aside>

          <div className="mx-auto mt-12 max-w-5xl text-center" data-id="element-367">
            <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-16 w-full items-center justify-center rounded-full bg-[#3f603d] px-8 text-sm font-bold tracking-[0.07em] text-white shadow-[0_12px_24px_rgba(48,69,46,0.16)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304d30] hover:shadow-[0_16px_30px_rgba(48,69,46,0.22)]" data-id="element-368">
              QUIERO MI SISTEMA COMPLETO
            </a>
            <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3 text-xs font-medium text-[#5c6c57]" data-id="element-369">
              <span data-id="element-370">🔒 Pago 100% seguro</span>
              <span data-id="element-371">⚡ Acceso inmediato</span>
              <span data-id="element-372">📥 Descarga digital</span>
              <span data-id="element-373">💚 Acceso para siempre</span>
              <span data-id="element-374">📱 Compatible con todos los dispositivos</span>
            </div>
          </div>

          <div className="mx-auto mt-16 max-w-3xl text-center" data-id="element-375">
            <p className="font-display text-2xl leading-9 text-[#3f563b] sm:text-3xl" data-id="element-376">
              Tu alimentación puede cambiar desde hoy. Miles de pequeñas
              decisiones construyen grandes resultados.
            </p>
            <p className="mt-6 leading-8 text-[#62705f]" data-id="element-377">
              Hoy puedes dar el primer paso con un sistema diseñado para
              acompañarte cada día, ayudarte a comer mejor y convertir una
              alimentación saludable en un hábito que realmente puedas mantener.
            </p>
            <p className="font-display mt-7 text-2xl text-[#3f563b]" data-id="element-378">
              Tu mejor inversión siempre será tu salud.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-379">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-380">
          <div className="grid gap-8 lg:grid-cols-[1.2fr_.8fr] lg:items-end" data-id="element-381">
            <div data-id="element-382">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-383">
                EXPERIENCIAS DE LA COMUNIDAD
              </p>
              <h2 className="font-display mt-5 max-w-3xl text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-384">
                Miles de personas buscan una forma más sencilla de comer
                saludable… Esto es lo que más valoran de Código Fitness™
              </h2>
            </div>
            <div className="border-l-2 border-[#b3c3a8] pl-5 text-sm leading-7 text-[#667361] sm:pl-7" data-id="element-385">
              <p data-id="element-386">
                Cada persona vive un proceso diferente. Estos comentarios
                representan los aspectos que más suelen valorar quienes buscan
                una alimentación práctica, deliciosa y sostenible.
              </p>
              <p className="mt-4" data-id="element-387">
                Nuestro objetivo es ayudarte a crear hábitos que puedas mantener
                durante toda la vida.
              </p>
              <p className="mt-5 text-xs leading-5 text-[#7c8878]" data-id="element-388">
                Comentarios representativos e ilustrativos de la comunidad; no
                corresponden a reseñas verificadas de compradores.
              </p>
            </div>
          </div>

          <div className="-mx-5 mt-14 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-5 md:mx-0 md:grid md:grid-cols-4 md:gap-5 md:overflow-visible md:px-0 md:pb-0" data-id="element-389">
            {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.42,
            delay: index % 4 * 0.05
          }} className="flex min-h-[290px] min-w-[278px] snap-start flex-col rounded-2xl border border-[#e1e4da] bg-[#fffefa] p-6 shadow-[0_9px_22px_rgba(56,69,50,0.06)] transition duration-300 md:min-w-0 md:hover:-translate-y-1 md:hover:shadow-[0_15px_30px_rgba(56,69,50,0.11)]" data-id="element-390">
                <div className="flex items-center justify-between gap-3" data-id="element-391">
                  <img src={testimonial.image} alt={`Avatar ilustrativo de ${testimonial.name}`} className="h-11 w-11 rounded-full object-cover" data-id="element-392" />
                  <div className="flex text-[#a57d2a]" aria-label="5 de 5 estrellas" data-id="element-393">
                    {Array.from({
                  length: 5
                }).map((_, starIndex) => <StarIcon key={starIndex} fill="currentColor" size={13} data-id="element-394" />)}
                  </div>
                </div>
                <blockquote className="mt-6 text-[15px] leading-7 text-[#4e5c4a]" data-id="element-395">
                  “{testimonial.quote}”
                </blockquote>
                <p className="mt-auto border-t border-[#e5e7df] pt-5 text-sm font-semibold text-[#40533d]" data-id="element-396">
                  {testimonial.name}
                </p>
              </motion.article>)}
          </div>

          <aside className="mt-12 border border-[#d8e1d0] bg-[#eef3e9] px-7 py-8 sm:px-10 sm:py-9" aria-labelledby="decision-title" data-id="element-397">
            <div className="flex flex-col gap-5 sm:flex-row sm:items-start" data-id="element-398">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#fffefa] text-[#a57d2a] shadow-sm" aria-hidden="true" data-id="element-399">
                <StarIcon fill="currentColor" size={20} data-id="element-400" />
              </span>
              <div data-id="element-401">
                <h3 id="decision-title" className="font-display text-3xl text-[#354a33]" data-id="element-402">
                  Tu cambio comienza con una decisión
                </h3>
                <p className="mt-4 max-w-4xl leading-7 text-[#586754]" data-id="element-403">
                  Miles de personas quieren mejorar su alimentación, pero pocas
                  encuentran una guía realmente práctica. Código Fitness™ fue
                  creado para ayudarte a comer mejor con recetas sencillas,
                  herramientas útiles y hábitos que puedas mantener a largo
                  plazo. Hoy tienes acceso inmediato a todo el sistema para
                  comenzar cuando tú decidas.
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section id="preguntas" className="bg-[#e9ebdf] py-24 sm:py-32" data-id="element-404">
        <div className="mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[.7fr_1.3fr]" data-id="element-405">
          <div data-id="element-406">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-407">
              TODO CLARO
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-408">
              Preguntas frecuentes
            </h2>
            <p className="mt-6 max-w-sm leading-7 text-[#62705e]" data-id="element-409">
              Si necesitas ayuda adicional, nuestro equipo de soporte estará
              encantado de orientarte.
            </p>
          </div>
          <div className="border-t border-[#cfd5c7]" data-id="element-410">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="border-b border-[#cfd5c7]" data-id="element-411">
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 py-6 text-left font-medium text-[#384b36]" aria-expanded={isOpen} data-id="element-412">
                    <span data-id="element-413">{question}</span>
                    <ChevronDownIcon className={`shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-414" />
                  </button>
                  {isOpen && <div className="max-w-xl pb-6 leading-7 text-[#62705e]" data-id="element-415">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <FinalOffer data-id="element-416" />

      <footer className="bg-[#263624] px-5 py-12 text-[#d8e1d0] sm:px-8" data-id="element-417">
        <div className="mx-auto max-w-7xl" data-id="element-418">
          <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-419">
            <div data-id="element-420">
              <p className="text-xs font-bold tracking-[0.18em] text-white" data-id="element-421">
                CÓDIGO FITNESS™
              </p>
              <p className="mt-4 max-w-xs text-sm leading-6" data-id="element-422">
                “Pequeños cambios diarios pueden transformar toda una vida.”
              </p>
            </div>
            <nav className="flex flex-wrap gap-x-6 gap-y-3 text-xs" aria-label="Enlaces legales" data-id="element-423">
              <a href="/politica-de-privacidad" className="transition-colors hover:text-white" data-id="element-424">
                Política de Privacidad
              </a>
              <a href="/terminos-y-condiciones" className="transition-colors hover:text-white" data-id="element-425">
                Términos y Condiciones
              </a>
              <a href="/politica-de-reembolsos" className="transition-colors hover:text-white" data-id="element-426">
                Política de Reembolsos
              </a>
              <a href="/descargo-de-responsabilidad" className="transition-colors hover:text-white" data-id="element-427">
                Descargo de Responsabilidad
              </a>
            </nav>
          </div>

          <div className="mt-10 border-t border-[#719061]/30 pt-7" data-id="element-428">
            <p className="max-w-4xl text-xs leading-6 text-white/75" data-id="element-429">
              Al completar tu compra aceptas nuestros Términos y Condiciones.
              Debido a la naturaleza digital de este producto y al acceso
              inmediato a todos los archivos descargables, no se aceptan
              devoluciones, cambios ni reembolsos una vez confirmada la compra.
            </p>
            <p className="mt-5 text-xs text-white/75" data-id="element-430">
              © 2026 Código Fitness™. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    </>;
}